<template>
  <div id="user-edit-tab-info" class="new-rt-crt-popup">
    <div class="row">
      <div class="col-md-12">
        <div class="custom-head-wrap">
          <input
            type="text"
            name="Title"
            class="form-control mb-0"
            v-model="data_local.TableName"
            placeholder="Table Name*"
          />
          <!-- <span class="text-danger text-sm"
            >This field is required</span
          > -->
        </div>
      </div>
      <div class="col-md-6 w-full">
        <div class="border text-center">
          <div class="flex justify-content-center">
            <img
              :src="imgSrc"
              class="mr-8 rounded mt-2 roundtable-image-wrap"
            />
            <!-- <vs-avatar :src="data_local.ProfilePictureURL" size="80px" class="mr-4" /> -->
            <div>
              <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
              <v-btn class="mr-4 mb-4">Upload</v-btn>
              <!-- <v-btn type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</v-btn> -->

              <!--<v-btn type="border" color="danger">Remove Avatar</v-btn>-->
            </div>
          </div>
          <p>High quality image: 960x192 px (2:1 ratio)</p>
        </div>
      </div>

      <div class="col-md-6 w-full">
        <label>Select Group</label>
        <div class="track-wrapper">
          <v-autocomplete
            height="50px"
            class=""
            dense
            outlined
            v-model="data_local.Topic"
            :items="RTTopicList"
            item-text="TopicDisplayName"
            return-object
          />
          <!-- <span class="text-danger text-sm" >{{
            errors.first("Topic")
          }}</span> -->
          <v-btn
            class="ml-3 px-5"
            color="primary"
            height="50px"
            type="filled"
            @click="openRTTopicPopup"
            >Add</v-btn
          >
          <v-dialog
            v-model="rtTopicDialog"
            transition="dialog-top-transition"
            max-width="500"
            scrollable
          >
            <template>
              <v-card class="invite-mod ss-cns-body-wrap">
                <div style="position: absolute; right: 10px; top: 15px">
                  <v-icon
                    style="z-index: 2"
                    size="32"
                    @click="rtTopicDialog = false"
                    >mdi-close</v-icon
                  >
                </div>
                <v-card-title
                  ><h5 class="pb-4">Create a New Group</h5>
                </v-card-title>
                <v-card-text>
                  <div class="invite-user-head">
                    <div
                      class="
                        d-flex
                        justify-content-center
                        align-items-center
                        mt-3
                      "
                    >
                      <div class="w-full group-creation-wrapper">
                        <label class="mb-2">Group Name </label>
                        <input
                          class="w-full form-control mb-0"
                          v-model="TopicName"
                        />
                        <div class="group-person-count">
                          <label class="mr-5">No of Seats </label>
                          <input
                            class="form-control"
                            name="Table Capacity"
                            v-model="TableCapacity"
                            type="number"
                            :min="2"
                            :max="300"
                          />
                        </div>
                        <div class="w-full">
                          <v-btn
                            outlined
                            color="#1c1d26"
                            class="mr-2 cancel-standard"
                            width="100px"
                            type="border"
                            @click="rtTopicDialog = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="primary"
                            type="filled"
                            class="save-standard"
                            @click="addRTTopic"
                            >Add Group</v-btn
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </template>
          </v-dialog>
        </div>
      </div>
    </div>
    <!-- Content Row -->
    <div class="row">
      <div class="col-md-6 w-full">
        <label>
          Select Host
          <span class="rqrd">*</span>
        </label>
        <v-autocomplete
          height="50px"
          dense
          outlined
          :items="AttendeeList"
          item-text="Name"
          v-model="data_local.Host"
          return-object
          :disabled="
            data_local.TableId != '' && data_local.StreamingClient.includes('Zoom')
          "
        />
      </div>

      <div class="col-md-6 w-full">
        <label> Select Co Host </label>
        <v-autocomplete
          height="50px"
          dense
          outlined
          :items="AttendeeList"
          item-text="Name"
          v-model="data_local.CoHost"
          return-object
          :disabled="
            data_local.TableId != '' && data_local.StreamingClient.includes('Zoom')
          "
        ></v-autocomplete>
      </div>
      <div class="col-md-6 w-full">
        <label>Streaming Client</label>
        <div class="w-full">
          <v-radio-group
            v-model="data_local.StreamingClient"
            mandatory
            row
            :disabled="data_local.TableId != ''"
          >
            <v-radio
              value="Web"
              label="Web"
              color="#1976d2"
              name="StreamingClient"
              class=""
              >Web</v-radio
            >
            <v-radio
              class=""
              label="Zoom Client"
              value="Zoom"
              color="#1976d2"
              name="Streaming Client"
              >Zoom Client</v-radio
            >
            <v-radio
              class=""
              value="ZoomWeb"
              label="Zoom Web"
              name="StreamingClient"
              color="#1976d2"
              >Zoom Web</v-radio
            >
            <v-radio
              class=""
              label="Custom"
              value="Custom"
              color="#1976d2"
              name="StreamingClient"
              >Custom</v-radio
            >
          </v-radio-group>
        </div>

        <div
          v-if="['Zoom', 'ZoomWeb'].includes(data_local.StreamingClient)"
          class="w-full"
        >
          <label>Approval Type</label>
          <v-select
            height="50px"
            dense
            outlined
            :clearable="false"
            :disabled="data_local.TableId != ''"
            item-text="Name"
            item-value="Id"
            :items="[
              { Name: 'Open Meeting', Id: 2 },
              //{Name:'Need Approval', Id:1},
              { Name: 'Need Registration', Id: 0 },
            ]"
            v-model="data_local.approval_type"
          />
        </div>
        <div v-if="data_local.StreamingClient == 'Custom'" class="w-full">
          <label>
            Custom Link
            <span class="rqrd">*</span>
          </label>
          <input
            class="w-full form-control"
            name="CustomLink"
            v-model="data_local.CustomLink"
          />
          <!-- <span class="text-danger text-sm">{{
          errors.first("CustomLink")
        }}</span> -->
        </div>
      </div>
      <div class="col-md-6 w-full">
        <label>Table Type</label>
        <div class="w-full">
          <v-radio-group v-model="data_local.PreAssigned" mandatory row>
            <v-radio label="Open" color="#1976d2" :value="falseValue"></v-radio>
            <v-radio
              label="Pre-assigned"
              color="#1976d2"
              :value="trueValue"
            ></v-radio>
          </v-radio-group>
        </div>

        <div class="w-full" v-if="data_local.PreAssigned">
          <label>Map Attendees</label>
          <v-autocomplete
            style="min-height: 50px"
            outlined
            chips
            multiple
            :closeOnSelect="false"
            v-model="data_local.MappedAttendees"
            v-on:input="limiter"
            :items="AttendeeList"
            item-text="Email"
            return-object
          />
        </div>

        <!-- <div
          class="vx-col md:w-2/12 w-full mt-4"
          v-if="
            data_local.StreamingClient == 'Web' && data_local.TableType == 'Open'
          "
        >
          <label>Spectate</label>
          <div class="mt-4">
            <vs-switch
              v-model="data_local.Spectate"
              :disabled="!spectateEnabled"
              name="Spectate"
            >
              <span slot="true">True</span>
              <span slot="false">False</span>
            </vs-switch>
          </div>
        </div> -->
      </div>

      <div class="col-md-6 w-full">
        <v-checkbox
          v-model="data_local.MapTo.IsMapped"
          label="Map To"
          :disabled="data_local.TableId != ''"
        ></v-checkbox>

        <v-radio-group
          v-if="data_local.MapTo.IsMapped"
          v-model="data_local.MapTo.Type"
          mandatory
          row
          :disabled="data_local.TableId != ''"
        >
          <v-radio
            :class="data_local.MapTo.Type == 'Exhibitor' ? 'active' : ''"
            label="Exhibitor"
            value="Exhibitor"
            >Exhibitor</v-radio
          >
          <v-radio
            :class="data_local.MapTo.Type == 'Sponsor' ? 'active ml-3' : 'ml-3'"
            label="Sponsor"
            value="Sponsor"
            >Sponsor</v-radio
          >
        </v-radio-group>
        <div
          v-if="
            data_local.MapTo.IsMapped && data_local.MapTo.Type == 'Exhibitor'
          "
          class="w-full"
        >
          <label>Exhibitor</label>
          <v-autocomplete
            height="50px"
            dense
            outlined
            :items="ExhibitorList"
            item-text="Name"
            v-model="data_local.MapTo.Entity"
            :disabled="data_local.TableId != ''"
            return-object
          />
        </div>
        <div
          v-if="data_local.MapTo.IsMapped && data_local.MapTo.Type == 'Sponsor'"
          class="w-full"
        >
          <label>Sponsor</label>{{SponsorList}}
          <v-autocomplete
            height="50px"
            dense
            outlined
            :items="SponsorList"
            item-text="Name"
            v-model="data_local.MapTo.Entity"
            :disabled="data_local.TableId != ''"
            return-object
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 w-full">
        <label>Is Published</label>
        <div class="">
          <v-switch
            v-model="data_local.IsPublished"
            color="info"
            hide-details
          ></v-switch>
        </div>
      </div>

      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          invite-action-group
        "
      >
        <div
          class="
            invite-action-buttons
            d-flex
            justify-content-between
            align-items-center
            full-width
          "
        >
          <!--<v-btn
            outlined
            color="#1c1d26"
            class="mr-2 cancel-standard"
            width="100px"
            @click="rtAddEditDialog = false"
            >Cancel</v-btn
          >-->

          <div class="btn-l-hld">
            <v-btn
              outlined
              color="#1c1d26"
              class="mr-2 cancel-standard"
              width="150px"
              @click="rtAddEditDialog = false"
              >Back To List</v-btn
            >
          </div>
          <div class="btn-r-hld">
            <v-btn
              outlined
              color="#1c1d26"
              class="mr-2 cancel-standard"
              width="100px"
              type="border"
              @click="reset_data"
              >Reset</v-btn
            >
            <v-btn class="" color="primary" @click="saveRoundTable"
              >Save &amp; Exit</v-btn
            >
          </div>
        </div>
      </div>
    </div>
    <!-- Save & Reset Button -->

    <!-- <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup> -->
  </div>
</template>

<script>
import db from "../components/firebaseInit";
import axios from "axios";
import APIs from "@/components/APIInit";
import { bus } from "@/main";
var vm;
export default {
  props: {
    event_collectionName: {
      type: String,
      default: "",
    },
    clientId: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
    data_local: {
      type: Object,
      default: () => ({
        TableId: "",
        TableName: "",
        Topic: null,
        Host: null,
        CoHost: null,
        StreamingClient: "Web",
        approval_type: 0,
        CustomLink: "",
        PreAssigned: false,
        MapTo: { IsMapped: false, Type: 0, Entity: {} },
        IsPublished: true,
        MappedAttendees: [],
        Capacity: 2,
      }),
    },
  },
  data() {
    return {
      data_local1: {
        TableId: "",
        TableName: "",
        Topic: null,
        Host: null,
        CoHost: null,
        StreamingClient: "Web",
        approval_type: 0,
        CustomLink: "",
        PreAssigned: false,
        MapTo: { IsMapped: false, Type: 0, Entity: {} },
        IsPublished: true,
        MappedAttendees: [],
        Capacity: 2,
      },
      imgSrc: "",
      falseValue: false,
      trueValue: true,
      popupActive: false,
      TopicName: "",
      TableCapacity: 2,
      AttendeeList: [],
      ExhibitorList: [],
      SponsorList: [],
      RTTopicList: [],
      rtTopicDialog: false,
      rtTopicKey: 0,
    };
  },
  created() {
    vm = this;
    vm.getRoundTableTopics();
    vm.getAttendeeList();
    vm.getExhibitorList();
    vm.getSponsorList();
  },
  watch: {
    // "data_local.Host"() {
    //   var result = [];
    //   if (vm.data_local.Host) {
    //     result = vm.AttendeeList.filter((row) => {
    //       return vm.data_local.Host[0].AttendeeId != row.AttendeeId;
    //     });
    //   }
    //   vm.data_local.Host = result;
    // },
  },
  methods: {
    openRTTopicPopup() {
      vm.TopicName = "";
      vm.TableCapacity = 2;
      vm.rtTopicDialog = true;
      vm.rtTopicKey++;
    },
    addRTTopic() {
      if (!vm.TopicName) {
        vm.showSnackbar("Group Name is mandatory", "error", "top");
        return;
      } else if (!vm.TableCapacity) {
        vm.showSnackbar("No. of Seats is mandatory", "error", "top");
        return;
      } else {
        // vm.RTTopicList.push({
        //   TopicId: 999999,
        //   TopicName: vm.TopicName,
        //   TableCapacity: vm.TableCapacity,
        //   TopicDisplayName: vm.TopicName + " (" + vm.TableCapacity + ")",
        // });
        // vm.data_local.Topic = vm.RTTopicList[vm.RTTopicList.length - 1];
        // vm.rtTopicDialog = false;
      //ADD API
        bus.$emit("toggleLoader", true);
        var RTTopic = {};
        RTTopic = {
          TopicName: vm.TopicName,
          TableCapacity: vm.TableCapacity,
          IsPrivate: true,
        };
        const headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        var key = {
          instanceId: "OA_UAT",
          clientId: vm.$store.state.client[0].id,
          eventId: vm.$store.state.eventid,
        };

        axios
          .post(
            APIs.AddRTTopic,
            { key: key, data: RTTopic },
            { headers: headers }
          )
          .then((response) => {
            debugger;
            bus.$emit("toggleLoader", false);
            if (response.data.TopicId) {
              vm.showSnackbar("Group Created", "info", "top");
              
              vm.RTTopicList.push({
                TopicId: response.data.TopicId,
                TopicName: vm.TopicName,
                TableCapacity: vm.TableCapacity,
                TopicDisplayName: vm.TopicName + " (" + vm.TableCapacity + ")",
              });
              vm.data_local.Topic = vm.RTTopicList[vm.RTTopicList.length - 1];
              vm.rtTopicDialog = false;
              // resolve({ status: 200, message: 'Data Added.' });
              console.log();
            } else {
              // resolve({ status: 500, message: 'Data Not Added.' })
              console.log();
            }
          })
          .catch(function (error) {
            debugger;
            bus.$emit("toggleLoader", false);
            console.log("Error adding RTTopic:", error);
            // reject(error)
          });
      }
    },
    reset_data() {},
    saveRoundTable() {
      if (!vm.data_local.TableName) {
        vm.showSnackbar("Table Name is mandatory", "error", "top");
        return;
      } else if (!vm.data_local.Topic) {
        vm.showSnackbar("Group is mandatory", "error", "top");
        return;
      } else if (!vm.data_local.Host) {
        vm.showSnackbar("Host is mandatory", "error", "top");
        return;
      } else {
        bus.$emit("toggleLoader", true);
        var RTSubmit = {};
        var capacity = 2;
        if (vm.data_local.Topic) {
          capacity = vm.data_local.Topic.TableCapacity;
        }
        RTSubmit = {
          TableName: vm.data_local.TableName,
          Capacity: capacity,
          Host: [vm.data_local.Host],
          CoHost: vm.data_local.CoHost,
          PreAssigned: vm.data_local.PreAssigned,
          StreamingClient: vm.data_local.StreamingClient,
          StreamingClientLink: "",
          approval_type: vm.data_local.approval_type,
          CustomLink: vm.data_local.CustomLink,
          SpectatorEnabled: "",
          MappedAttendees: vm.data_local.MappedAttendees,
          CreatedByName: "",
          CreatedByID: "221000",
          IsPublished: vm.data_local.IsPublished,
          Topic: vm.data_local.Topic,
          //Topic: { TopicId: "221000", TopicName: "Abcd" },
          MapTo: vm.data_local.MapTo,
          RoundtableLogo: "",
        };
        if (vm.data_local.TableId) {
          RTSubmit.TableId = vm.data_local.TableId;
        }
        const headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        var key = {
          instanceId: "OA_UAT",
          clientId: vm.$store.state.client[0].id,
          eventId: vm.$store.state.eventid,
        };

        axios
          .post(
            APIs.RoundTableWriteAPI,
            { key: key, data: RTSubmit },
            { headers: headers }
          )
          .then((response) => {
            if (response.data.TableId) {
              bus.$emit("toggleLoader", false);
              vm.$emit("OnAddRTSuccess");
              vm.showSnackbar("Round Table Created", "info", "top");
              // resolve({ status: 200, message: 'Data Added.' });
              console.log();
            } else {
              // resolve({ status: 500, message: 'Data Not Added.' })
              console.log();
            }
          })
          .catch(function (error) {
            bus.$emit("toggleLoader", false);
            console.log("Error adding attendee:", error);
            // reject(error)
          });
      }
    },
    getRoundTableTopics1() {
      vm.RTTopicList = [];
      db.collection(vm.event_collectionName) //"OA_UAT_C1591205467009E1591206650065")
        .doc("RoundTableTopicList")
        .collection("RoundTableTopics")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            vm.RTTopicList.push({
              TopicId: doc.data().TopicId,
              TopicName: doc.data().TopicName,
              TableCapacity: doc.data().TableCapacity,
              TopicDisplayName:
                doc.data().TopicName + " (" + doc.data().TableCapacity + ")",
            });
          });
        });
    },
    getRoundTableTopics() {
      vm.RTTopicList = [];
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${vm.getSessionToken()}`,
          instanceId: "OA_UAT",
          clientId: vm.getClientId(),
          eventId: vm.getEventId(),
        };
        axios
          .get(APIs.GetAllRtTopic, { headers: headers })
          .then(function (res) {
            if (res.data.status == 0 && res.data.results.length) {
              for (let item of res.data.results) {
                vm.RTTopicList.push({
                  TopicId: item.TopicId,
                  TopicName: item.TopicName.trim(),
                  TopicDisplayName:
                    item.TopicName.trim() +
                    " (" +
                    (item.TableCapacity == undefined
                      ? 12
                      : item.TableCapacity) +
                    ")",
                  TableCapacity:
                    item.TableCapacity === undefined ? 12 : item.TableCapacity,
                });
              }
            }
            resolve();
          })
          .catch((err) => {
            alert(err)
            reject(err);
          });
      });
    },

    getAttendeeList() {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.$store.state.client[0].id,
            eventId: vm.$store.state.eventid,
          },
          data: {
            search: [],
            filter: [
              {
                key: "IsPublished",
                operator: "==",
                value: true,
              },
            ],
            sort: { sortBy: "FirstName", sortOrder: "asc" },
            pagination: {
              Page: 1,
              PageSize: 9999,
            },
            origin: "COMPACT",
          },
        };
        axios
          .post(APIs.AttendeeSearch, requestData, { headers: headers })
          .then(function (res) {
            if (res.data.status == 0 && res.data.result.length) {
              res.data.result.forEach((item) => {
                vm.AttendeeList.push({
                  AttendeeId: item.AttendeeId,
                  FirstName: item.FirstName,
                  LastName: item.LastName,
                  Name: item.Name,
                  Email: item.Email,
                  Company: item.Company,
                  Designation: item.Designation,
                  ProfilePictureURL: item.ProfilePictureURL,
                });
              });
            }
            resolve(vm.AttendeeList);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getExhibitorList() {
      vm.ExhibitorList = [];
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
        instanceId: "OA_UAT",
        clientId: vm.getClientId(),
        eventId: vm.getEventId(),
      };
      axios
        .get(APIs.ExhibitorSelfServiceFetchApi, { headers: headers })
        .then((response) => {
          console.log("response====", response);
          for (let data of response.data.results) {
            vm.ExhibitorList.push({ Id: data.ExhibitorId, Name: data.Name });
          }
        });
    },

    getSponsorList() {
      vm.SponsorList = [];
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
        instanceId: "OA_UAT",
        clientId: vm.getClientId(),
        eventId: vm.getEventId(),
      };
      axios
        .get(APIs.GetSponsors, { headers: headers })
        .then((response) => {
          //alert("response====", response);
          //console.log("response====", response);
          for (let data of response.data.results) {
            vm.SponsorList.push({ Id: data.SponsorId, Name: data.Name });
          }
          //vm.SponsorList = response.data.results;
          
        })
        .catch((err) => {
          console.log(err);
        });
      // db.collection(vm.event_collectionName)
      //   .doc("SponsorList")
      //   .collection("Sponsors")
      //   .get()
      //   .then((snap) => {
      //     for (let doc of snap.docs) {
      //       var data = doc.data();
      //       vm.SponsorList.push({ Id: data.SponsorId, Name: data.Name });
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
  },
};
</script>

<style>
</style>